import useErrorReporter from './useErrorReporter'
import noticeError from '../services/noticeError'

const { useCallback, useEffect, useState } = require('react')

// Stop checking popup status eventually just in case it's closed or got into an error state
// using 11 minutes since Authn is only allowing up to 10 minutes for the user to complete the flow
const POPUP_POLLING_TIMEOUT = 11 * 60 * 1000

export default function usePopup({ finalUrl, onSuccess, setErrorCode, errorParamName = 'error' }) {
  const [popup, setPopup] = useState(null)
  const reportError = useErrorReporter()
  const openPopup = useCallback(
    (url) => {
      const left = window.screenX + window.innerWidth / 2 - 300
      const top = window.screenY + window.innerHeight / 2 - 300
      const windowProxy = window.open(url, 'popup', `top=${top},left=${left},width=600,height=600`)
      if (!windowProxy) {
        reportError(new Error('Failed to open popup'))
      } else {
        setPopup(windowProxy)
      }
    },
    [reportError]
  )
  useEffect(() => {
    if (!popup) {
      return null
    }
    const interval = setInterval(() => {
      if (!popup) {
        clearInterval(interval)
        return
      }
      let currentUrl
      try {
        currentUrl = popup.location.href
      } catch (error) {
        // do nothing--this is expected when the popup is cross-origin
        return
      }
      if (currentUrl?.includes(finalUrl)) {
        clearInterval(interval)
        setPopup(null)
        popup.close()
        const searchParams = new URL(currentUrl).searchParams
        const code = searchParams.get(errorParamName)
        if (code) {
          setErrorCode?.(code)
          noticeError(new Error(`The popup URL has URL code param = ${code}`))
        } else {
          onSuccess?.()
        }
      }
    }, 500)
    const stopInterval = setTimeout(() => {
      clearInterval(interval)
    }, POPUP_POLLING_TIMEOUT)
    return () => {
      clearInterval(interval)
      clearTimeout(stopInterval)
    }
  }, [popup, finalUrl, onSuccess, setErrorCode, errorParamName])
  return openPopup
}
